/**
 * Created by Jiu Chen on 12/03/2018.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Action } from '@ngrx/store';

export enum EntityTypeActionTypes {
    INITIALIZE = '[ENTITY_TYPE] INITIALIZE',
    INITIALIZE_SUCCESS = '[ENTITY_TYPE] INITIALIZE_SUCCESS',
    INITIALIZE_FAILED = '[ENTITY_TYPE] INITIALIZE_FAILED'
}

export class Initialize implements Action {
    readonly type = EntityTypeActionTypes.INITIALIZE;
}

export class InitializeSuccess implements Action {
    readonly type = EntityTypeActionTypes.INITIALIZE_SUCCESS;

    constructor(public payload: any) { }
}

export class InitializeFailed implements Action {
    readonly type = EntityTypeActionTypes.INITIALIZE_FAILED;

    constructor(public payload: any) { }
}

export type EntityTypeActions = Initialize | InitializeSuccess | InitializeFailed;
